import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Block from "../../components/Block/Block";
import {
  BLOCKCHAIN_BLOCKS,
  BLOCKCHAIN_PEERS,
} from "../../constants/blockchain";
import {
  difficulty,
  difficultyPattern,
  maximumNonce,
  SHA256,
} from "../../utils";

const Distributed: React.FC = () => {
  const [hashBlocks, setHashBlocks] = useState<any>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeIndex, setActiveIndex] = useState<any>(null);

  const handleDataChange = (event: any, chain: number, index: number) => {
    const value = event && event.target ? event.target.value : event;
    const key = event.target.name;

    let prevState = [...hashBlocks];
    let prevBlock = prevState[chain].blocks;
    prevBlock[index] = {
      ...prevBlock[index],
      [key]: value,
    };

    prevState[chain] = {
      ...prevState[chain],
      blocks: prevBlock,
    };

    setHashBlocks(updateChain(prevState, chain));
  };

  const updateChain = (prevState: any, chain: number) => {
    prevState.forEach((item: any, index: number) => {
      let prevBlocks = item.blocks;
      prevBlocks.forEach((block: any, idx: number) => {
        if (chain === index) {
          if (idx > 0) {
            const prev = prevBlocks[idx - 1];
            const hash = updateHash(
              block.block,
              block.nonce,
              block.data,
              prev.hash
            );
            block.previous = prev.hash;
            block.hash = hash;
          } else {
            const hash = updateHash(
              block.block,
              block.nonce,
              block.data,
              block.previous
            );
            block.hash = hash;
          }
        } else {
          const hash = updateHash(
            block.block,
            block.nonce,
            block.data,
            block.previous
          );
          block.hash = hash;
        }
      });
    });
    return prevState;
  };

  const updateHash = (block: any, nonce: any, data: any, previous: any) => {
    return SHA256(
      `${String(block)}${String(nonce)}${String(data)}${String(previous)}`
    );
  };

  const onMineClick = (e: any, chain: number, index: number) => {
    e.preventDefault();
    setIsSubmitting(true);
    setActiveIndex(index);

    let prevState = [...hashBlocks];
    const item = prevState[chain];
    let prevBlocks = item.blocks;
    let prevBlock = prevBlocks[index];

    for (var x = 0; x <= maximumNonce; x++) {
      const hashValue = updateHash(
        prevBlock.block,
        x,
        prevBlock.data,
        prevBlock.previous
      );

      if (hashValue.substr(0, difficulty) === difficultyPattern()) {
        prevBlocks[index] = {
          ...prevBlocks[index],
          nonce: x,
          hash: hashValue,
        };

        prevState[chain] = {
          ...prevState[chain],
          blocks: prevBlocks,
        };
        setHashBlocks(updateChain(prevState, chain));
        break;
      }
    }

    setTimeout(function () {
      setIsSubmitting(false);
      setActiveIndex(null);
    }, 250);
  };

  useEffect(() => {
    const newPeers = BLOCKCHAIN_PEERS.map((peer) => {
      const newBlocks = BLOCKCHAIN_BLOCKS.map((item) => {
        const data = "";
        const hash = updateHash(item.block, item.nonce, data, item.previous);
        return {
          ...item,
          data,
          hash,
          isSubmitting: false,
        };
      });
      return {
        ...peer,
        blocks: newBlocks,
      };
    });
    setHashBlocks(newPeers);
  }, []);

  return (
    <Container fluid>
      <h1>Distributed Blockchain</h1>
      {hashBlocks.map((peer: any, index: number) => {
        return (
          <div className="my-3" key={index}>
            <h3>Peer {peer.user}</h3>
            <Row className="row-horizon flex-row">
              {peer.blocks.map((block: any, index1: number) => {
                return (
                  <Col xs={5} className="mb-3" key={index1}>
                    <Block
                      block={block.block}
                      chain={block.chain}
                      nonce={block.nonce}
                      previous={block.previous}
                      data={block.data}
                      hashText={block.hash}
                      isSubmitting={isSubmitting && activeIndex === index1}
                      handleDataChange={(e) =>
                        handleDataChange(e, index, index1)
                      }
                      onSubmit={(e) => onMineClick(e, index, index1)}
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
        );
      })}
    </Container>
  );
};

export default Distributed;
